import { faWrench } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Tooltip, Whisper } from 'rsuite';

export default function defineSensorId() {
    return (
        <div data-cy="history-defineSensor-id">
            <Whisper
                placement="right"
                trigger="hover"
                speaker={
                    <Tooltip>
                        <FormattedMessage id="history.defineSensorId" />
                    </Tooltip>
                }>
                <FontAwesomeIcon icon={faWrench} style={{ color: 'orange' }} size="lg" />
            </Whisper>
        </div>
    );
}
